<template>
    <div class="p-3">
        <h3>RL 3.8 Kegiatan Pelayanan Laboratorium</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Laboratorium" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-lab',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columnMinWidth: 80,
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",

                    },
                    {
                        title: "Jenis Kegiatan",
                        field: "NMDetail",
                    },
                    {
                        title: "Jumlah Pemeriksaan",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "jumlah_l",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "jumlah_p",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Nilai Rata-Rata Pemeriksaan",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "laki",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "perempuan",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Total Kunjungan",
                        field: "jumlah",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
